import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { setGlobalToast } from "../api/fetcher";

// Component to initialize global toast for the fetcher
export default function ToastInitializer({
  children,
}: {
  children: React.ReactNode;
}) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const toast = {
      success: (message: string) =>
        enqueueSnackbar(message, { variant: "success" }),
      error: (message: string) =>
        enqueueSnackbar(message, { variant: "error" }),
      warning: (message: string) =>
        enqueueSnackbar(message, { variant: "warning" }),
      info: (message: string) => enqueueSnackbar(message, { variant: "info" }),
    };

    // Set the global toast instance
    setGlobalToast(toast);
  }, [enqueueSnackbar]);

  return <>{children}</>;
}
